import React from 'react';
import { Heading, Text } from '../common/Typography';
import {
  ClubManagementIconWell,
  ClubSectionIcon,
  MANAGEMENT_ICON_TONES,
} from './dashboard/ClubSectionIcons';

export const ManagementSection = ({ iconType, title, subtitle, children, className = '' }) => {
  const accentText = MANAGEMENT_ICON_TONES[iconType]?.text ?? 'text-text-secondary';

  return (
    <section className={className}>
      <div className="mb-3">
        <div className="flex min-w-0 items-center gap-3">
          <span className={`shrink-0 ${accentText}`}>
            <ClubSectionIcon type={iconType} className="h-6 w-6 sm:h-7 sm:w-7" />
          </span>
          <Heading level={2} className="min-w-0 truncate text-lg font-bold text-text-primary sm:text-xl">
            {title}
          </Heading>
        </div>
        {subtitle ? (
          <Text className="mt-0.5 text-xs text-text-secondary sm:text-sm">{subtitle}</Text>
        ) : null}
      </div>
      <div className="space-y-2">{children}</div>
    </section>
  );
};

export const ManagementActionRow = ({
  iconType,
  title,
  description,
  onClick,
  actions,
  disabled = false,
}) => {
  const rowBody = (
    <>
      <ClubManagementIconWell type={iconType} />
      <div className="min-w-0 flex-1">
        <div className="font-semibold text-text-primary">{title}</div>
        {description ? (
          <div className="mt-0.5 line-clamp-2 text-xs text-text-secondary sm:text-sm">{description}</div>
        ) : null}
      </div>
    </>
  );

  const trailing = actions ?? (
    <span className="shrink-0 px-1 text-sm font-medium text-primary" aria-hidden>
      →
    </span>
  );

  if (onClick && !disabled) {
    return (
      <div className="flex w-full min-h-[44px] items-center gap-2 rounded-xl border border-border-medium bg-surface p-2 shadow-brand-sm transition-all hover:border-primary/30 hover:shadow-brand-md sm:p-3 sm:gap-3">
        <button
          type="button"
          onClick={onClick}
          className="flex min-w-0 flex-1 items-center gap-3 text-left touch-manipulation focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 active:scale-[0.99]"
        >
          {rowBody}
        </button>
        {actions ? <div className="flex shrink-0 items-center gap-2 pr-1">{actions}</div> : trailing}
      </div>
    );
  }

  return (
    <div className="flex w-full min-h-[44px] items-center gap-3 rounded-xl border border-border-medium bg-surface p-2 text-left shadow-brand-sm sm:p-3">
      {rowBody}
      {trailing}
    </div>
  );
};
